export const environment = {
  production: false,
  apiUrl: 'https://stagedash.odeum.io',
  apiUrl2: 'https://apistage.odeum.io',
  stripeKey: 'pk_test_p0wrO4YsC1op4u3nRZAmrnRE',
  hostname: undefined,
  algoliaIndex: undefined
};
